import { caseDetailDiv } from '.'
import startCase from 'lodash/startCase'
import { replaceInitialValuesAndDates } from 'utils/tinyMCE/replaceInitialValues'
import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'
import { insertTemplate } from '../insertMenu/insertTemplate'
import addSpansToParagraphs from 'utils/tinyMCE/updateDynamicText/addSpansToParagraphs'
import {
  PLAIN_TEXT_BLOCK_PATHS,
  plainTextBlockToHtml,
} from './plainTextBlockHtml'

export const handleTextBlock = (
  editor,
  caseDetails,
  key,
  templates,
  dateFormat,
  label,
  selectedTheme,
  pageSetLocale,
) => {
  let themeStyles = getThemeStylesForTemplate({
    selectedTheme,
    editor,
  })

  // A plain-text block takes one paragraph per line; any other block fills
  // its placeholder from the case.
  const content = PLAIN_TEXT_BLOCK_PATHS.has(key)
    ? caseDetailDiv(key, themeStyles).replace(
        `{$${key}}`,
        plainTextBlockToHtml(caseDetails?.[key]) || '\u200A',
      )
    : replaceInitialValuesAndDates(
        caseDetailDiv(key, themeStyles),
        caseDetails,
        dateFormat,
        pageSetLocale,
      )

  themeStyles = 'font-size: 11pt;' + themeStyles

  const contentWithSpans = addSpansToParagraphs(content, themeStyles)

  const menuItem = {
    type: 'menuitem',
    text: label ?? `${startCase(key)}`,
    onAction: () => insertTemplate(editor, contentWithSpans),
  }

  templates.push(menuItem)
}

export default handleTextBlock
